import { render, staticRenderFns } from "./ReferralCode.vue?vue&type=template&id=02efad1c&scoped=true"
import script from "./ReferralCode.vue?vue&type=script&lang=js"
export * from "./ReferralCode.vue?vue&type=script&lang=js"
import style0 from "./ReferralCode.vue?vue&type=style&index=0&id=02efad1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02efad1c",
  null
  
)

export default component.exports